import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { ILimits } from '../../MailCheck/interfaces';
import { IServerErrorResponse } from '../../../types';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import { endpointManager } from '../../../services/endpoint.service';

export const getMailLimits = () => {
  const { getMailCheckLimitsUrl } = endpointManager();

  return useQuery(
    'getMailLimits',
    async () => {
      const res = await httpService.get(getMailCheckLimitsUrl());
      return res.data as ILimits;
    },
    {
      refetchOnWindowFocus: false,
      retry: 0,
      enabled: false,
      staleTime: 0,
      cacheTime: 0,
      onError: (e:IServerErrorResponse) => {
        const { localizedMessage, code } = flattenServerErrorResponse(e);
        trackMixPanel('Error Occurred During Move Money Flow', {
          'Error Code': code, 'Error Message': localizedMessage, 'Screen Name': 'Intro', Flow: 'Mail a Check',
        });
      },
    },
  );
};
